<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
<!--              <el-form-item label="消费卡">-->
<!--                  <el-input  style="width: 177px;" v-model="queryForm.cardId"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item label="订单">
                  <el-input  style="width: 177px;" v-model="queryForm.orderId"></el-input>
              </el-form-item>
              <el-form-item label="用户">
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 177px;" labelName="userName"
                       labelValue="id" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                       @getValue="getSeachValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="使用金额">
                  <el-input  style="width: 177px;" v-model="queryForm.useMoney"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopCardUseList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addShopCardUse"-->
<!--        >新建</el-button>-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editShopCardUse(null)"-->
<!--        >修改</el-button>-->
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteShopCardUse(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          title="下载模板"
          class="icon-box"
          @click="importTemplate"
        >
          <Icon color="#606266">
            <ArrowDown />
          </Icon>
        </span>
        <span
          class="icon-box"
          title="导入数据"
          @click="isImport"
        >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span>
        <span
          title="导出数据"
          class="icon-box"
          @click="exportShopCardUseList"
        >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshShopCardUseList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopCardUseList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="id"-->
<!--        label="ID"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="cardId"
        label="消费卡"
        width="180"
      >
          <template slot-scope='scope'>
              <span>{{scope.row.card.cardNumber}}</span>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderId"
        label="订单"
        width="180"
      >
          <template slot-scope='scope'>
              <span>{{scope.row.shopOrder ? scope.row.shopOrder.orderPrice : ''}}</span>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if='scope.row.user'>
                  <div class="car_text" style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                  <div class="car_text" style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                  <div class="car_text" style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                  <div class="car_text" style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
              </div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="useMoney"
        label="使用金额"
        width="180"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="createUserId"-->
<!--        label="创建者"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="updateUserId"-->
<!--        label="更新者"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="updateTime"-->
<!--        label="更新时间"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="deleteFlag"-->
<!--        label="是否删除 0 正常 1 删除"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkShopCardUse(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
<!--            <div @click="editShopCardUse(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
            <div @click="deleteShopCardUse(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopCardUseStates[shopCardUseState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
      :modal="false"
    >
      <div>
        <el-form
          :model="shopCardUse"
          ref="shopCardUseForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
<!--          <el-form-item-->
<!--            label="ID"-->
<!--            prop="id"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopCardUse.id"-->
<!--              :disabled="shopCardUseState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="消费卡"
            prop="cardId"
          >
            <el-input
              size="small"
              v-model="shopCardUse.cardId"
              :disabled="shopCardUseState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="订单"
            prop="orderId"
          >
            <el-input
              size="small"
              v-model="shopCardUse.orderId"
              :disabled="shopCardUseState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="用户"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopCardUse.userId"-->
<!--              :disabled="shopCardUseState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" title="选择用户" labelName="userName" :disabled="shopCardUseState == 'check'"
                   labelValue="id" :value="shopCardUse.userId" :limit='1' size='small' placeholder='请选择用户'
                   @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="使用金额"
            prop="useMoney"
          >
            <el-input
              size="small"
              v-model="shopCardUse.useMoney"
              :disabled="shopCardUseState == 'check'"
            ></el-input>
          </el-form-item>
<!--          <el-form-item-->
<!--            label="创建者"-->
<!--            prop="createUserId"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopCardUse.createUserId"-->
<!--              :disabled="shopCardUseState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item-->
<!--            label="创建时间"-->
<!--            prop="createTime"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopCardUse.createTime"-->
<!--              :disabled="shopCardUseState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item-->
<!--            label="更新者"-->
<!--            prop="updateUserId"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopCardUse.updateUserId"-->
<!--              :disabled="shopCardUseState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item-->
<!--            label="更新时间"-->
<!--            prop="updateTime"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopCardUse.updateTime"-->
<!--              :disabled="shopCardUseState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item-->
<!--            label="是否删除 0 正常 1 删除"-->
<!--            prop="deleteFlag"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopCardUse.deleteFlag"-->
<!--              :disabled="shopCardUseState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopCardUseState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant.js';

export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopCardUseList();
                    this.getShopCardUseList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopCardUseList();
                    this.getShopCardUseList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     cardId: '', //消费卡
                     orderId: '', //订单
                     userId: '', //用户
                     useMoney: '', //使用金额
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopCardUseState: 'add',
                shopCardUseStates: {
                    add: '新建shop_card_use',
                    check: '查看shop_card_use',
                    edit: '修改shop_card_use'
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                multipleSelection: [],
                shopCardUseList: [],
                shopCardUse: {
                    id: '', //ID
                    cardId: '', //消费卡
                    orderId: '', //订单
                    userId: '', //用户
                    useMoney: '', //使用金额
                    createTime: '', //创建时间
                },
                btnLoading: false,

                rules: {
                    cardId: [{ required: true, message: '消费卡不能为空', trigger: 'blur' }],
                    orderId: [{ required: true, message: '订单不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    useMoney: [{ required: true, message: '使用金额不能为空', trigger: 'blur' }]
                }
            };
        },
        created() {
            // this.getShopCardUseList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getValueUser(value) {
                this.shopSorting.userId = value
            },
            getSeachValueUser(value){
                this.queryForm.userId = value
            },
            show(id){
                this.queryForm.cardId = id;
                this.resetShopCardUseList()
                this.getShopCardUseList()
            },
            resetShopCardUseList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopCardUseList = [];
            },
            resetDialog() {
                this.shopCardUseState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      cardId: this.queryForm.cardId, //消费卡
                      orderId: '', //订单
                      userId: '', //用户
                      useMoney: '', //使用金额
                };
                this.getShopCardUseList();
            },
            closeDialog() {
                this.showDialog = false
                this.shopCardUse = {
                      id: '', //ID
                      cardId: '', //消费卡
                      orderId: '', //订单
                      userId: '', //用户
                      useMoney: '', //使用金额
                };
            },
            submitForm() {
                if (this.shopCardUseState == 'add') {
                    this.$refs.shopCardUseForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/carduse/add`,{ ...this.shopCardUse }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopCardUseList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopCardUseState == 'edit') {
                    this.$refs.shopCardUseForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/carduse/edit`,{ ...this.shopCardUse }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopCardUseList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopCardUse() {
                this.showDialog = true;
                this.shopCardUseState = 'add';
            },
            checkShopCardUse(shopCardUseId) {
                console.log(shopCardUseId);
                this.currentShopCardUseId = shopCardUseId;

                this.getShopCardUseById();
                this.showDialog = true;
                this.shopCardUseState = 'check';
            },
            editShopCardUse(shopCardUseId) {
                console.log('shopCardUse', shopCardUseId);
                if (shopCardUseId) {
                    this.currentShopCardUseId = shopCardUseId;
                    this.getShopCardUseById();
                } else {
                    this.shopCardUse = { ...this.shopCardUse, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopCardUseState = 'edit';
            },
            deleteShopCardUse(shopCardUseId) {
                let ids = '';
                if (shopCardUseId) {
                    ids = shopCardUseId;
                } else {
                    ids = this.multipleSelection.map((shopCardUse) => shopCardUse.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/carduse/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopCardUseList();
                                this.getShopCardUseList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopCardUseList() {
                this.resetShopCardUseList();
                this.getShopCardUseList();
            },
            getShopCardUseList(query = {}) {
                this.loading = true;
                get(`/shop/carduse/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopCardUseList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopCardUseById() {
                get(`/shop/carduse/get`,{ id: this.currentShopCardUseId }).then((res) =>{
                    if(res.success){
                      this.shopCardUse = { ...this.shopCardUse, ...res.shopCardUse };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopCardUseList() {
                //this.btnLoading = true;
                exprotExcel(`/shop/carduse/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/shop/carduse/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/shop/carduse/importData`,formData);
              this.refreshShopCardUseList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopCardUseList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopCardUseList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>